<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="categoryOperate">
        <el-pagination background layout="prev, pager, next" :current-page="pageNum"
                       @current-change="pageChange"
                       :total="totalNum" v-if="paginationShow"></el-pagination>
      </div>
      <div class="categoryTable">
        <el-table ref="multipleTable" :data="list" tooltip-effect="dark" style="width: 100%" border>
          <el-table-column prop="id" label="序号" width="60"/>
          <el-table-column prop="name" label="门店名称" width="160"/>
          <el-table-column prop="typeId" label="门店分类" width="160">
            <template slot-scope="scope">
              <span>{{ getType(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="discount" label="买单折扣" width="160"/>
          <el-table-column prop="detailed" label="详细地址" width="160">
            <template slot-scope="scope">
              <span>{{ getAddress(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="linkman" label="联系人" width="160"/>
          <el-table-column prop="phone" label="联系电话" width="160"/>
          <el-table-column prop="isPick" label="同城自提" width="80">
            <template slot-scope="scope">
              <span>{{ !scope.row.isPick ? '否' : '是' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="postage" label="同城配送" width="80">
            <template slot-scope="scope">
              <span>{{ !scope.row.postage ? '否' : '是' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="postage" label="同城配送费用" width="120"/>
          <el-table-column prop="status" label="状态" width="60">
            <template slot-scope="scope">
              <span>{{ getStatus(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" show-overflow-tooltip>
            <template slot-scope="scope" >
              <el-button v-if="scope.row.status==0" size="mini" @click="onAgree(scope.$index, scope.row)">同意</el-button>
              <el-button v-if="scope.row.status==0" size="mini" @click="onReject(scope.$index, scope.row)">拒绝</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--      拒绝弹框-->
      <el-dialog title="拒绝理由"
                 :visible.sync="showRejectModal"
                 :append-to-body=true
                 width="40%"
                 :modal=false>
        <el-form label-position="left" label-width="80px">
          <el-form-item label="理由:">
            <el-input v-model="checkRemark"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showRejectModal = false">取 消</el-button>
          <el-button type="primary" @click="onRejectModalOk()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {Loading} from 'element-ui'
import MSidebar from 'components/header/sidebar'
import MHeader from 'components/header/header'
import {getStoreAuditList, postStoreAudit, getStoreType} from 'api/request'
import {ERR_OK} from 'api/config'
import {loadingInstance, Error} from 'common/js/util'

export default {
  components: {MSidebar, MHeader},
  data () {
    return {
      status: 1,
      pageSize: 10,
      pageNum: 1,
      totalPage: 0,
      paginationShow: false,
      list: [],
      showRejectModal: false, // 拒绝理由弹框
      checkRemark: null, // 拒绝理由
      editRow: null, // 编辑内容
      storeTypeList: [] // 门店类型列表
    }
  },
  mounted () {
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'))
    if (!getUserInfo) {
      this.$router.push({
        path: '/'
      })
    } else {
      this.getStoreType()
      this._getList()
    }
  },
  methods: {
    getAddress (row) {
      return row.province + row.county + row.city + (row.street || '') + row.detailed
    },
    getType (row) {
      let thisStore = this.storeTypeList.find(item => item.id === row.typeId) || {}
      return thisStore.name
    },
    getStatus (row) {
      if (row.status === 0) return ''
      if (row.status === -1) return '拒绝'
      if (row.status === 1) return '同意'
    },
    // 点击分页
    pageChange (val) {
      this.pageNum = val
      this.categoryDatas = []
      this._getList()
    },
    // 填写完拒绝理由
    onRejectModalOk () {
      if (!this.checkRemark) {
        this.$message('请填写拒绝理由')
        return
      }
      let param = {
        id: this.editRow.id,
        status: -1,
        checkRemark: this.checkRemark
      }
      loadingInstance(Loading)
      postStoreAudit(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.checkRemark = null
          this.showRejectModal = false
          this.$message('已拒绝')
          this._getList()
        } else {
          Error(this, res)
        }
      })
    },
    // 拒绝
    onReject (index, row) {
      this.showRejectModal = true
      this.editRow = row
    },
    // 同意
    onAgree (index, row) {
      let param = {
        id: row.id,
        status: 1,
        checkRemark: ''
      }
      loadingInstance(Loading)
      postStoreAudit(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.$message('已同意')
          this._getList()
        } else {
          Error(this, res)
        }
      })
    },
    // 门店分类
    getStoreType () {
      loadingInstance(Loading)
      getStoreType().then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.storeTypeList = res.data
        } else {
          Error(this, res)
        }
      })
    },
    // 获取列表
    _getList () {
      let param = {
        current: this.pageNum,
        size: this.pageSize
      }
      loadingInstance(Loading)
      getStoreAuditList(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.list = res.data.records
          this.totalNum = res.data.total
          if (res.data.pages > 1) {
            this.paginationShow = true
          }
        } else {
          Error(this, res)
        }
      })
    }
  }
}
</script>
<style scoped>
.categoryOperate {
  height: 40px;
  margin: 20px;
  box-sizing: border-box;
}

.categoryTable {
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
}
</style>
<style>
.el-tag + .el-tag {
  margin: 5px;
}

.categoryOperate .el-input {
  width: 180px;
  height: 40px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}

.categoryOperate .el-button {
  width: 100px;
  height: 40px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/store/pageAudit.vue